import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isMobile } from '../../lib/deviceDetect';

declare global {
  interface Window {
    Beacon?: Function;
  }
}

export const BeaconManager = () => {
  const location = useLocation();
  const [isInitialized, setInitialized] = useState<boolean>(false);
  useEffect(() => {
    let disallowedPaths = ['/services/track'];
    const beacon = window && window.Beacon;
    if (!beacon) return;
    if (isMobile && disallowedPaths.includes(location.pathname)) {
      if (isInitialized) {
        beacon('destroy');
        setInitialized(false);
      }
    } else {
      if (!isInitialized) {
        beacon('init', '65431882-e3ca-4d2b-9580-8474ea7d252d');
        setInitialized(true);
      }
    }
  }, [isInitialized, location.pathname]);
  return <></>;
};
